import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Tooltip } from "react-tooltip";
import { getDateFormat } from "@utils/datePickerUtils";
import { Image } from "hesus-ui-kit";
import lowIcon from "@icons/ic-priority-low.svg";
import normalIcon from "@icons/ic-priority-normal.svg";
import highIcon from "@icons/ic-priority-high.svg";
import { DivBackgroundOpacity, DivToolTip } from "@utils/extra-style";
import "../../EnquiryList.scss";

const Priority = (props) => {
  const { t, data } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={data?.isActive === 1 ? 1 : "0.2"}>
        {parseInt(data.step, 10) === 1 && (
          <>
            {parseInt(data.priority, 10) === 3 && (
              <>
                <Image
                  src={lowIcon}
                  alt={t("ENQUIRY_PRIORITY_LOW")}
                  title={t("ENQUIRY_PRIORITY_LOW")}
                  id={`enquiry-low-tooltip-id${data.id}`}
                  className="enquiry-listing__image-icon"
                />
                <Tooltip
                  anchorSelect={`#enquiry-low-tooltip-id${data.id}`}
                  style={DivToolTip}
                  content={
                    t("ENQUIRY_PRIORITY_LOW") +
                    " - " +
                    t("ENQUIRY_DUE_DATE") +
                    " " +
                    getDateFormat(data.dueDate, "YYYY-MM-DD")
                  }
                />
              </>
            )}
            {parseInt(data.priority, 10) === 2 && (
              <>
                <Image
                  src={normalIcon}
                  alt={t("ENQUIRY_PRIORITY_NORMAL")}
                  title={t("ENQUIRY_PRIORITY_NORMAL")}
                  id={`enquiry-normal-tooltip-id${data.id}`}
                  className="enquiry-listing__image-icon"
                />
                <Tooltip
                  anchorSelect={`#enquiry-normal-tooltip-id${data.id}`}
                  style={DivToolTip}
                  content={
                    t("ENQUIRY_PRIORITY_NORMAL") +
                    " - " +
                    t("ENQUIRY_DUE_DATE") +
                    " " +
                    getDateFormat(data.dueDate, "YYYY-MM-DD")
                  }
                />
              </>
            )}
            {parseInt(data.priority, 10) === 1 && (
              <>
                <Image
                  src={highIcon}
                  alt={t("ENQUIRY_PRIORITY_HIGH")}
                  title={t("ENQUIRY_PRIORITY_HIGH")}
                  id={`enquiry-high-tooltip-id${data.id}`}
                  className="enquiry-listing__image-icon"
                />
                <Tooltip
                  anchorSelect={`#enquiry-high-tooltip-id${data.id}`}
                  style={DivToolTip}
                  content={
                    t("ENQUIRY_PRIORITY_HIGH") +
                    " - " +
                    t("ENQUIRY_DUE_DATE") +
                    " " +
                    getDateFormat(data.dueDate, "YYYY-MM-DD")
                  }
                />
              </>
            )}
          </>
        )}
      </DivBackgroundOpacity>
    </>
  );
};

Priority.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Priority);
